@use "@fukuri-admins/ui/layout" as *;

.root {
  width: 100%;
}

.tabList {
  display: flex;
  box-sizing: border-box;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  scrollbar-width: none; /* Firefox */
  border-bottom: 1px solid border("Tertiary");
  padding: 0;
  margin: 0;
}
.tabList::-webkit-scrollbar { display: none; } /* WebKit */

.tabListItem {
  flex: 0 0 auto;
}

.tabButton {
  position: relative;
  background: none;
  border: 0;
  width: 100%;
  cursor: pointer;
  outline: none;
  padding: 0;
  height: 40px;
  box-sizing: border-box; /* 境界線込みで40pxに収める */
  display: flex;
  align-items: center;
  /* 非選択時も同じ描画領域を確保するため透明の内側下線を定義 */
  box-shadow: inset 0 -2px 0 0 transparent;
}

/* 選択時のボーダー */
.tabButton[data-selected='true'] {
  /* 内側に2pxのラインを描画（レイアウトへ影響なし） */
  box-shadow: inset 0 -2px 0 0 border("Gray_Darken");
}

.tabButton[disabled] {
  cursor: not-allowed;
  background-color: background("Primary");
}
.tabButton[disabled] .text {
  color: text("Disabled");
}
/* hoverの上書きを回避 */
.tabButton[disabled]:hover {
  background-color: background("Primary");
}

.tabButton[disabled][data-selected='true'] {
  box-shadow: inset 0 -2px 0 0 border("Quaternary");
}
.tabButton[disabled][data-selected='true'] .text {
  color: text("Disabled");
}

/* 未選択時のみフォーカスリングを表示 */
.tabButton:not([data-selected='true']):focus-visible {
  border-radius: 4px;
  box-shadow: inset 0 0 0 2px border("Focus"), inset 0 -2px 0 0 transparent;
}

/* テキスト要素自体にパディング・表示特性を付与（従来は.label） */
.text {
  display: inline-flex;
  align-items: center;
  padding: 0 spacing("16");
  color: text("High");
  line-height: 1;
  @include typography("Jp/14_W3");
}

.tabButton:hover {
  background-color: background("Overlay_Bl_5");
}

.tabButton[data-selected='true'] .text {
  color: text("High");
  @include typography("Jp/14_W6");
}
